<template>
<div id="schritt-2">

    <b-row class="cc-point-title-container mt-2">
        <b-col class="col-2 pt-1"><img src="../assets/mobileline.png"></b-col>
        <b-col class="col-8"><h3 id="cost"  class="cc-point-title">Schritt 2 - Marketing und Vertrieb</h3></b-col>
        <b-col class="col-2 pt-1"></b-col>
    </b-row>


    <div class="page-paddings">
        <div class="cc-questions-container">


            <div class="point-container">
                <div class="row mt-3">
                    <p class="point-number">7. </p>
                    <p class="point-name"> Umsatzstrategie</p>
                </div>

                <div class="col">
                    <b-form-radio-group
                            v-model="selection2.selected7"
                            :options="options7"
                            class="mb-3 input-pad-big"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                    ></b-form-radio-group>

                </div>
            </div>

            <div class="point-container">
                <div class="row">
                    <p class="point-number">8. </p>
                    <p class="point-name"> Eigenes Bezahlsystem innerhalb der App?</p>
                </div>

                <div class="col">
                    <b-form-radio-group
                            v-model="selection2.selected8"
                            :options="options8"
                            class="mb-3 input-pad-big"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                    ></b-form-radio-group>

                </div>


            </div>


            <div class="point-container">
                <div class="row">
                    <p class="point-number">9. </p>
                    <p class="point-name"> Wie soll Ihre App verbreitet werden?</p>
                </div>

                <div class="col">
                    <b-form-radio-group
                            v-model="selection2.selected9"
                            :options="options9"
                            class="mb-3 input-pad-big"
                            value-field="item"
                            text-field="name"
                            disabled-field="notEnabled"
                    ></b-form-radio-group>

                </div>
            </div>

            <b-row>
                <b-row class="text-right amount-row">
                    <b-col class="col-5"><p class="amount-text mt-3 text-right">Kosten - Schritt 2</p></b-col>
                    <b-col class="col-7"><b-button class="amount-button pl-1  ml-1 text-center">€ {{get2cost}}  </b-button></b-col>
                </b-row>
            </b-row>

        </div>
    </div>
    <b-row class="entry-part-end">
        <b-button @click="nextStep" class="cc-button text-center mx-auto">Weiter</b-button>
    </b-row>
</div>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                Cost1: 0,
                Cost2: '',
                text1: '',
                text2: '',
                formatter: '',
                // total1: 0,
                total2: 0,
                total3: 0,
                value: 0,
                selection2: {
                    selected7: '',
                    selected8: '',
                    selected9: ''
                },
                result1: '',
                options7: [
                    { item: 'A', name: 'Werbung' },
                    { item: 'B', name: 'In-App-Käufe' },
                    { item: 'C', name: 'kostenpflichtiger Download' },
                    { item: 'D', name: 'All4Free' }
                ],
                options8: [
                    { item: 'A', name: 'Ja' },
                    { item: 'B', name: 'Nein' }
                ],
                options9: [
                    { item: 'A', name: 'App Stores' },
                    { item: 'B', name: 'Nutzer erhält Link' }

                ]

            }
        },
        mounted() {
            if ('selection2' in localStorage) {
                this.selection2 = JSON.parse(localStorage.getItem('selection2'))
            }
            this.Cost1 = this.$route.params.cost1;
            // localStorage.clear();
            // document.querySelectorAll('[data-id]').forEach(item => {
            //     item.addEventListener('mouseover', () => {
            //         item.querySelector('[data-comment]').classList.add('visible');
            //     });
            //     item.addEventListener('mouseout', () => {
            //         item.querySelector('[data-comment]').classList.remove('visible');
            //     })
            // })
        },
        computed: {

            get2cost () {
                // let total1 = 1;
                let total7 = 0;
                let total8 = 0;
                let total9 = 0;

                // if (this.selected1 === 'A') {
                //     localStorage.setItem('total1', 1.5);
                // } else if ( this.selected1 === 'B') {
                //     localStorage.setItem('total1', 1);
                // } else if ( this.selected1 === 'C') {
                //     localStorage.setItem('total1', 0.8);
                // } else if ( this.selected1 === 'D') {
                //     localStorage.setItem('total1', 0.5);
                // }

                if (this.selection2.selected7 === 'A') {
                    total7 = 1.1;
                } else if ( this.selection2.selected7 === 'B') {
                    total7 = 1.2;
                } else if ( this.selection2.selected7 === 'C') {
                    total7 = 1.1;
                } else if ( this.selection2.selected7 === 'D') {
                    total7 = 0;
                }

                if (this.selection2.selected8 === 'A') {
                    total8 = 1.2;
                } else if ( this.selection2.selected8 === 'B') {
                    total8 = 0;
                }

                if (this.selection2.selected9 === 'A') {
                    total9 = 1.1;
                } else if ( this.selection2.selected9 === 'B') {
                    total9 = 0;
                }

                let get2cost = this.isZero(localStorage.getItem('total1')) * Math.round(1500 * (total7 + total8 + total9));


                localStorage.setItem('get2cost',get2cost)
                return Math.round(get2cost);
            },

        },
        methods: {
            nextStep() {
                localStorage.setItem('selection2', JSON.stringify(this.selection2));
                this.$router.push(
                    {
                        name: 'Schritt3',
                        params: {
                            cost1: this.Cost1,
                            cost2: this.get2cost,

                        }
                    }
                )
            },
            changeCalView (){

                if ( this.selected3 === 'B') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    console.log(document.getElementById('b2b'))
                } else if (this.selected3 === 'C') {
                    document.getElementById('b2c2').classList.add("clickedb2b");
                    document.getElementById('b2b2').classList.remove("clickedb2b");
                    console.log('C')
                } else if (this.selected3 === 'A') {
                    document.getElementById('b2b2').classList.add("clickedb2b");
                    document.getElementById('b2c2').classList.remove("clickedb2b");
                    console.log('A')
                }
            },
            isZero(value) {
                if (value === 0) {
                    return 1
                }
                return value;
            }
        }
    }
</script>